import React from 'react';
import {FastField} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import CommonFields from './CommonFields';
import TooltipIcon from '../../../TooltipIcon';

class String1Type extends React.PureComponent {
    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <div className="row">
                    <div className="col-4">
                        <FastField name={`${name}.multiline`}>
                            {({field}) => (
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" name={field.name} id={field.name} className="custom-control-input"
                                        checked={field.value} onChange={field.onChange} />
                                    <label className="custom-control-label" htmlFor={field.name}>
                                        <FormattedMessage {...messages.surveys.form.label.multiline} />
                                    </label>
                                </div>
                            )}
                        </FastField>
                    </div>
                    <div className="col-4">
                        <FastField name={`${name}.sentimentAnalysis`}>
                            {({field}) => (
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" name={field.name} id={field.name} className="custom-control-input"
                                        checked={field.value} onChange={field.onChange} />
                                    <label className="custom-control-label" htmlFor={field.name}>
                                        <FormattedMessage {...messages.surveys.form.label.sentimentAnalysis} />
                                        {' '}
                                        <TooltipIcon message={messages.surveys.form.tooltip.sentimentAnalysis} />
                                    </label>
                                </div>
                            )}
                        </FastField>
                    </div>
                    <div className="col-4">
                        <FastField name={`${name}.entityExtraction`}>
                            {({field}) => (
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" name={field.name} id={field.name} className="custom-control-input"
                                        checked={field.value} onChange={field.onChange} />
                                    <label className="custom-control-label" htmlFor={field.name}>
                                        <FormattedMessage {...messages.surveys.form.label.entityExtraction} />
                                        {' '}
                                        <TooltipIcon message={messages.surveys.form.tooltip.entityExtraction} />
                                    </label>
                                </div>
                            )}
                        </FastField>
                    </div>
                </div>
            </>
        );
    }
}

export default String1Type;
